import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { CameraSliceTypes, createCameraSlice } from './createCameraSlice';
import createSelectors from './createSelectors';
import { createSessionSlice, SessionSliceTypes } from './createSessionSlice';
import { createUserSlice, UserSliceTypes } from './createUserSlice';

export type RemoteBoundStoreState = UserSliceTypes &
  CameraSliceTypes &
  SessionSliceTypes;

const useRemoteBoundStoreBase = create<RemoteBoundStoreState>()(
  immer(
    persist(
      devtools((...a) => ({
        ...createUserSlice(...a),
        ...createCameraSlice(...a),
        ...createSessionSlice(...a),
      })),
      {
        name: 'optain-app-remoteStore',
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);

const useRemoteBoundStore = createSelectors(useRemoteBoundStoreBase);

export default useRemoteBoundStore;
